/* Client-side downloads (CSV with BOM so Excel opens Arabic correctly, JSON). */
import { foldedRegionStats } from './stats.js'

export function download(name, content, type) {
  const a = document.createElement('a')
  a.href = URL.createObjectURL(new Blob([content], { type }))
  a.download = name; a.click(); URL.revokeObjectURL(a.href)
}
export const csvEsc = (v) => { v = String(v == null ? '' : v); return /[",\n]/.test(v) ? '"' + v.replace(/"/g, '""') + '"' : v }
const csv = (rows) => '﻿' + rows.map((r) => r.map(csvEsc).join(',')).join('\r\n')

export function exportCsvRegions(D) {
  const rows = [['Region', 'Participants', 'RatedAnswers', 'SatisfactionPct']]
  Object.values(foldedRegionStats(D)).sort((a, b) => b.participants - a.participants).forEach((r) => rows.push([r.region, r.participants, r.rated, r.satPct ?? '']))
  rows.push([]); rows.push(['Year', 'Positive', 'Neutral', 'Negative', 'SatisfactionPct']);
  (D.satisfactionByYear || []).filter((y) => y.year >= 2019 && y.year <= 2031).forEach((y) => rows.push([y.year, y.positive, y.neutral, y.negative, y.satPct ?? '']))
  download('regions-years.csv', csv(rows), 'text/csv;charset=utf-8')
}
export function exportCsvSurveys(D) {
  const rows = [['Id', 'NameAr', 'NameEn', 'Sector', 'Participants', 'Answers', 'Questions', 'SatisfactionPct', 'From', 'To', 'Located']];
  (D.leaderboard || []).forEach((r) => rows.push([r.id, r.nameAr, r.nameEn, r.sectorEn, r.participants, r.answers, r.questions, r.satPct ?? '', r.from, r.to, r.located || 0]))
  download('surveys.csv', csv(rows), 'text/csv;charset=utf-8')
}
export function exportJson(D) { download('dashboard-data.json', JSON.stringify(D, null, 2), 'application/json') }
export function exportSurveyCsv(sv) {
  const rows = [['Question', 'Option', 'Bucket', 'Year', 'Count']];
  (sv.qs || []).forEach((q) => {
    const qt = q.tAr || q.tEn || ('#' + q.id);
    (q.os || []).forEach((o) => {
      const ys = o.y || {}; const ks = Object.keys(ys)
      if (!ks.length) rows.push([qt, o.a || o.e, o.b || '', '', 0])
      ks.forEach((y) => rows.push([qt, o.a || o.e, o.b || '', y, ys[y]]))
    })
    if (q.tx) Object.keys(q.tx).forEach((y) => rows.push([qt, '(free text)', '', y, q.tx[y]]))
  })
  download('survey-' + sv.id + '-results.csv', csv(rows), 'text/csv;charset=utf-8')
}
export function exportTable(name, head, rows) {
  download(name, csv([head, ...rows.map((r) => r.map((v) => String(v == null ? '' : v).replace(/<[^>]+>/g, '')))]), 'text/csv;charset=utf-8')
}
